"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const redux_1 = require("redux");
const immutable_1 = require("immutable");
const react_redux_1 = require("react-redux");
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const mui_1 = require("tss-react/mui");
const TableContainer_1 = __importDefault(require("@mui/material/TableContainer"));
const Table_1 = __importDefault(require("@mui/material/Table"));
const TableBody_1 = __importDefault(require("@mui/material/TableBody"));
const accounts_1 = require("companion-app-components/flux/accounts");
const DialogHoc_1 = __importDefault(require("components/DialogHoc"));
const StdDialog_1 = __importDefault(require("components/Dialogs/StdDialog"));
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const utils_1 = require("utils/utils");
const TableHeader_1 = __importDefault(require("./TableHeader"));
const TableAccountRow_1 = __importDefault(require("./TableAccountRow"));
const styles_1 = require("../../styles");
const isIe = require('is-iexplorer') || (0, utils_1.isOldEdge)(); // eslint-disable-line
const useStyles = (0, mui_1.makeStyles)()(styles_1.calendarAccountsModalStyles);
const tableColumns = Object.freeze({
    checkBoxCol: {
        field: 'checkbox',
    },
    accountCol: {
        label: 'Account',
    },
    typeCol: {
        label: 'Type',
    },
    descriptionCol: {
        label: 'Description',
    },
});
const CalAccountsPrefsModal = ({ onClose, setDialog }) => {
    const { classes } = useStyles();
    const { datasetPreferences, setDatasetPreference } = (0, useQPreferences_1.default)();
    const [accountsToShow, setAccountsToShow] = (0, react_1.useState)((0, immutable_1.Set)());
    const accountsByIdData = (0, react_redux_1.useSelector)(accounts_1.accountsSelectors.getEntityShareAccountsById);
    const originalAccountsToShow = (0, react_1.useMemo)(() => datasetPreferences.calendarTransaction.accountsToShow, [datasetPreferences]) || (0, immutable_1.List)();
    const accountsById = (0, react_1.useMemo)(() => accountsByIdData && accountsByIdData.filterNot((account) => (account.type === 'INVESTMENT')), [accountsByIdData]);
    const hasChanges = (0, react_1.useMemo)(() => {
        if (originalAccountsToShow.size !== accountsToShow.size)
            return true;
        if (originalAccountsToShow.size && originalAccountsToShow.every((acc) => !accountsToShow.has(acc)))
            return true;
        return false;
    }, [originalAccountsToShow, accountsToShow]);
    const onCloseHandler = (0, react_1.useCallback)((event) => {
        if (event && hasChanges) {
            setDialog('Discard changes?', 'Are you sure you want discard all the changes', (dialog) => { if (['DISCARD', 'Enter'].includes(dialog.action))
                onClose(); }, ['CANCEL', 'DISCARD']);
        }
        else {
            onClose();
        }
    }, [onClose, hasChanges, setDialog]);
    const onDoneHandler = (0, react_1.useCallback)(() => {
        setDatasetPreference({ calendarTransaction: { accountsToShow } });
        onCloseHandler(false);
    }, [onCloseHandler, setDatasetPreference, accountsToShow]);
    const onResetHandler = (0, react_1.useCallback)(() => {
        setDatasetPreference({ calendarTransaction: { accountsToShow: accountsById.map((acc) => acc.id).toSet() } });
    }, [accountsById, setDatasetPreference]);
    const onChangeAccountsToShow = (0, react_1.useCallback)((id) => {
        if (!id)
            return;
        let newAccountsToShow;
        if (id === 'ALL') { // Select all accounts
            newAccountsToShow = accountsById.map((acc) => acc.id).toSet();
        }
        else if (id === 'CLEAR') { // Deselect all accounts
            newAccountsToShow = accountsToShow.clear();
        }
        else { // Toggle selection of single accounts
            newAccountsToShow = accountsToShow.has(id) ? accountsToShow.delete(id) : accountsToShow.add(id);
        }
        setAccountsToShow(newAccountsToShow);
    }, [setAccountsToShow, accountsToShow, accountsById]);
    (0, react_1.useEffect)(() => {
        if (originalAccountsToShow && (originalAccountsToShow === null || originalAccountsToShow === void 0 ? void 0 : originalAccountsToShow.size) >= 0) {
            setAccountsToShow((0, immutable_1.Set)(originalAccountsToShow));
        }
    }, [originalAccountsToShow]);
    return (<StdDialog_1.default open classes={isIe ? { paper: classes.dialogPaper } : {}} onClose={onCloseHandler} title="Calendar Accounts" maxWidth="xlg">
      <DialogContent_1.default>
        <div>Select accounts to include:</div>
        <TableContainer_1.default className={classes.tableContainer}>
          <Table_1.default stickyHeader padding="none" size="small">
            <TableHeader_1.default columns={tableColumns} classes={classes} selectedAccounts={accountsToShow.size} totalRows={accountsById.size} onChangeAccountsToShow={onChangeAccountsToShow}/>
            <TableBody_1.default>
              {accountsById.map((account) => (<TableAccountRow_1.default key={`row-${account.id}`} classes={classes} columns={tableColumns} selected={accountsToShow.has(account.id)} account={account} onChangeAccountsToShow={onChangeAccountsToShow}/>)).toList()}
            </TableBody_1.default>
          </Table_1.default>
        </TableContainer_1.default>
      </DialogContent_1.default>
      <div className={classes.buttonContainer}>
        <Button_1.default color="primary" onClick={onResetHandler} id="txn-pref-reset-to-defaults" className={classes.resetButton}>
          Reset To Defaults
        </Button_1.default>
        <div className={classes.buttonArea}>
          <Button_1.default color="primary" onClick={onCloseHandler} id="txn-modal-done">
            Cancel
          </Button_1.default>
          <Button_1.default color="primary" onClick={onDoneHandler} id="txn-modal-done" disabled={!hasChanges}>
            Done
          </Button_1.default>
        </div>

      </div>

    </StdDialog_1.default>);
};
exports.default = (0, redux_1.compose)((0, DialogHoc_1.default)())(react_1.default.memo(CalAccountsPrefsModal));
